import React, { useState, useMemo, useCallback } from 'react'
import { Icon } from '@arnsbogroup/react-voicearchive'
import Select, { components } from 'react-select'
import DemoPlayer from 'containers/SupplierProfile/components/DemoPlayer'
import { FormattedMessage, useIntl} from 'react-intl'
import messages from './messages'

const Control = (props) => (
  <components.Control {...props} className="border border-gray-300 px-3 py-2" />
)

const Option = (props) => {
  const { innerProps, data: { label, value, demo, unavailability } } = props
  const { formatDate, formatTime } = useIntl()

  return (
    <div {...innerProps} className="py-3 px-2 bg-white hover:bg-gray-100 cursor-pointer flex justify-between items-center">
      <div>
        {label}
      </div>
      <div className='flex gap-2 items-center'>
        {unavailability && !!unavailability.length && (
          <Icon 
            className="text-red-500" 
            icon={["fas", "user-alt-slash"]}
            title={unavailability.map(({ dateStart, dateEnd }) => 
              `${formatDate(new Date(dateStart * 1000))} ${formatTime(new Date(dateStart * 1000))} - ${formatDate(new Date(dateEnd * 1000))} ${formatTime(new Date(dateEnd * 1000))}`
            ).join('\n')}
          />
        )}
        {demo && <DemoPlayer src={demo} />}
      </div>
    </div>
  )
}

const VoiceTalent = ({ isMulti = false, attribute, state, onChange, ...props }) => {
  const { options, name, disabled } = attribute

  const value = useMemo(() => {
    if (isMulti) {
      const list = (state || []).map((v) => parseInt(v, 10))
      return options.filter(({ value }) => list.includes(parseInt(value, 10)))
    }

    return options.find(({ value }) => value == state)
  }, [state, options])

  const callback = useCallback((change) => {
    if (isMulti) {
      if (change) {
        return onChange(change.map(({ value }) => value))
      } else {
        return onChange([])
      }
    }

    return onChange(change.value)
  }, [isMulti, onChange])

  return (
    <fieldset className="space-y-2">
      <p className="text-xs font-medium text-gray-600 uppercase tracking-wider">
        { name }
      </p>

      <p className="text-sm text-gray-600">
        <FormattedMessage {...messages.description} />
      </p>

      <Select
        value={value}
        onChange={callback}
        options={options}
        openMenuOnFocus
        isDisabled={disabled}
        isMulti={isMulti}
        components={{
          Control,
          Option,
        }}
        styles={{
          placeholder: (base) => ({ ...base, color: '#9eaebf', fontSize: '0.875rem' }),
          singleValue: (base) => ({ ...base, color: '#1a202c', fontSize: '0.875rem' }),
          valueContainer: (base) => ({ ...base, color: '#1a202c', fontSize: '0.875rem' }),
        }}
        theme={(theme) => ({
          ...theme,
            borderRadius: 0,
            colors: {
              ...theme.colors,
                neutral20: '#cbd5e0', // text-gray-400
                neutral30: '#718096', // text-gray-600
            },
        })}
        {...props}
      />
    </fieldset>
  )
}

export default VoiceTalent
